<div class="mat-form-field-wrapper">
  <mat-form-field>
    <label [for]="controlName">{{label}}<span *ngIf="required" class="required">*</span> 
      <mat-icon class="email-chips-tooltip" *ngIf="['bill_to_email_address', 'represented_contact_email'].includes(controlName)"
        mdTooltipClass="muti-line-tooltip" matTooltipPosition="above"
        matTooltip={{getToolTipText()}}>
        info
      </mat-icon>
    </label>
    <input
      *ngIf="controlName !=='bill_to_email_address' && controlName !== 'represented_contact_email'"
      matInput
      [id]="controlName"
      [type]="type"
      [matAutocomplete]="auto"
      [value]="fieldValue"
      (input)="setSuggestions($event.target.value)"
      (focus)="focus.emit()"
      (blur)="invokeBlur($event.target.value)"
      [disabled]="disabled"
    />
    <mat-chip-grid #chipList *ngIf="['bill_to_email_address', 'represented_contact_email'].includes(controlName)" [disabled]="disabled">
      <mat-chip-row class="email-chips"
        *ngFor="let email of emails"
        (removed)="remove(email)">
        {{email}}
        <button matChipRemove>
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip-row>
      <input 
        #emailInput
        [id]="controlName"
        [matAutocomplete]="auto"
        [matChipInputFor]="chipList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        (matChipInputTokenEnd)="add($event)"
        (input)="setSuggestions($event.target.value, $event)"
        [disabled]="disabled"
        [attr.maxLength]="getMaxLengthEmail()">
    </mat-chip-grid>
  </mat-form-field>
  <mat-autocomplete #auto [displayWith]="displayValue()">
    <mat-option *ngFor="let customerSuggestion of suggestions | async"
      (onSelectionChange)="contactSelectionChange(customerSuggestion, $event)">
      {{ customerSuggestion[field] }}
    </mat-option>
  </mat-autocomplete>
</div>
